import React, { useEffect, useState } from 'react'
import ConfirmationModal from '../../../Components/modal/ConfirmationModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SvgImages } from '../../../Utils/LocalImages';
import { ConfirmationModalTheme, ImageFilters } from '../../../Utils/Enums';
import ButtonWithIcon from '../../../Components/Reusable/ButtonWithIcon';
import Image from '../../../Components/Reusable/Image';
import generatePaginationFooter from '../../../Components/Reusable/CustomPagination';
import { handleApiErrors } from '../../../Utils/Utils';
import CoordinatorService from '../../../Services/CoordinatorService';
import DataProvider from '../../../Utils/DataProvider';
import SubAdminService from '../../../Services/SubAdmin';
import { toast } from 'react-toastify';
import RoutesPath from '../../../Utils/RoutesPath';
import SessionManager from '../../../Utils/Session';

const Privileges = () => {
    const location = useLocation();
    const previlagesData = location.state || {}
    const { role_id } = useParams();
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    // Initialize privileges using DataProvider
    const [privileges, setPrivileges] = useState(
        DataProvider.setPrivileges.map(item => ({
            ...item,
            read: true,
            create: true,
            update: true,
            delete: true,
        }))
    );
    const handleUpdatePrivileges = async () => {
        const privilegesToSend = privileges.map(({ label, read, create, update, delete: del }) => ({
            parameter: label, // Change label to parameter
            read,
            create,
            update,
            delete: del,
        }));

        try {
            await SubAdminService.updateRolePrivileges(
                role_id, // Use the roleId from the params
                privilegesToSend,
            ); // Send the entire payload
            toast.success("Privileges updated successfully");
            navigate(RoutesPath.roleList);
            SessionManager.shared.getData();
        } catch (error) {
            handleApiErrors(error);
        }
    };
    useEffect(() => {
        // Optionally set initial states from previlagesData if necessary
        if (previlagesData.setPrivileges) {
            const updatedPrivileges = privileges.map((privilege, index) => ({
                ...privilege,
                ...previlagesData.setPrivileges[index], // Merge existing values
            }));
            setPrivileges(updatedPrivileges);
        }
    }, [previlagesData]);

    return (
        <div>
            <div className="content" data-number="1">
                <div className="mb-3 d-flex justify-content-between align-items-center">
                    <h1 className="black fs-18 fw-600 mb-0">ROLES</h1>
                    <div className="d-flex">
                        <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                        <h4 className="fs-12 fw-500 primary mb-0">Role List</h4>
                    </div>
                </div>

                <div className="table_container" style={{ display: "block" }}>
                    <h1 className="black fs-18 fw-600 mb-0">Privileges</h1>

                    <div className="table_title">
                        <div className="table_headings mt-2 Commonclass">
                            <h1 className="black fs-18 fw-600 mb-0 d-flex gap-2">
                                <label className="d-flex align-items-center justify-content-center">
                                    <input
                                        className="cursor-pointer"
                                        type="checkbox"
                                        style={{ height: "16px", aspectRatio: 1 }}
                                        checked={privileges.length > 0 && privileges.every(item => item.read && item.create && item.update && item.delete)}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            const updatedPrivileges = privileges.map((privilege) => ({
                                                ...privilege,
                                                read: isChecked,
                                                create: isChecked,
                                                update: isChecked,
                                                delete: isChecked,
                                            }));
                                            setPrivileges(updatedPrivileges);
                                        }}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                <div
                                    className=""
                                    style={{
                                        opacity:
                                            data?.findIndex((item) => item.isChecked) == -1 ? 1 : 1,
                                    }}
                                >

                                    <div className='fs-16 fw-600 black' >Select All</div>
                                </div>
                            </h1>
                        </div>


                    </div>

                    <div style={{ overflowX: "auto" }}>
                        <table
                            className="table mb-0"
                            id="dtHorizontalExample"
                            cellSpacing="0"
                            width="100%"
                        >
                            <thead>
                                <tr className="table_heading">
                                    <th scope="col" style={{ width: "20%" }}>
                                        Parameters

                                    </th>
                                    <th scope="col" style={{ width: "20%" }}>
                                        Read
                                    </th>
                                    <th scope="col" style={{ width: "20%" }}>
                                        Create
                                    </th>
                                    <th scope="col" style={{ width: "20%" }}>
                                        Update
                                    </th>
                                    <th className="" scope="col" style={{ width: "20%" }}>
                                        Delete
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg_light">
                                {privileges?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.label}</td>
                                        <td className="">
                                            <label
                                                className="switch"
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={item.read}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        const updatedPrivileges = [...privileges];
                                                        updatedPrivileges[index] = {
                                                            ...updatedPrivileges[index],
                                                            read: isChecked,
                                                            // If read is false, set all other permissions to false as well
                                                            create: isChecked ? updatedPrivileges[index].create : false,
                                                            update: isChecked ? updatedPrivileges[index].update : false,
                                                            delete: isChecked ? updatedPrivileges[index].delete : false,
                                                        };
                                                        setPrivileges(updatedPrivileges);
                                                    }}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td className="">
                                            <label
                                                className="switch"
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={item.create} // Using privileges state
                                                    onChange={(e) => {
                                                        const updatedPrivileges = [...privileges];
                                                        updatedPrivileges[index].create = e.target.checked;
                                                        setPrivileges(updatedPrivileges);
                                                    }}
                                                    disabled={!item.read}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td className="">
                                            <label
                                                className="switch"
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={item.update} // Using privileges state
                                                    onChange={(e) => {
                                                        const updatedPrivileges = [...privileges];
                                                        updatedPrivileges[index].update = e.target.checked;
                                                        setPrivileges(updatedPrivileges);
                                                    }}
                                                    disabled={!item.read}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </td>
                                        <td className="">
                                            <label
                                                className="switch"
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={item.delete} // Using privileges state
                                                    onChange={(e) => {
                                                        const updatedPrivileges = [...privileges];
                                                        updatedPrivileges[index].delete = e.target.checked;
                                                        setPrivileges(updatedPrivileges);
                                                    }}
                                                    disabled={!item.read}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </td>


                                    </tr>
                                ))}
                            </tbody>
                        </table>


                    </div>
                    {/* {generatePaginationFooter(
                        availableDataCount,
                        limit,
                        offset,
                        setOffset
                    )} */}
                    <div className='row my-4'>
                        <div className=' col-8'></div>
                        <div className=' col-lg-4 d-flex justify-content-end'>
                            <div className='w-50 d-flex justify-content-end'>
                                <ButtonWithIcon
                                    text={"Update "}
                                    icon={SvgImages.tick_mark}
                                    onClick={handleUpdatePrivileges}
                                />
                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Privileges
